import { IPedidoFinalizar } from "shared/interfaces";
import { api } from "../api";

export async function finalizarPedido(
  pedido: IPedidoFinalizar,
  idempotencyKey: string
) {
  // v2: cobra o preço de cada combinação e baixa o estoque dela.
  const response = await api.post("/v2/orders", pedido, {
    headers: {
      "Idempotency-Key": idempotencyKey,
    },
  });

  return response.data;
}